<template>
    <div class="d-flex flex-column tst" v-if='this.normalizedFields' ref="inputsContainer">
        <div class='container-fluid p-0' v-for="(field, key) in this.normalizedFields" :key="key">
            <div v-if="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['visible']">
            <Switch v-if='field.type_field == "BOOL"'
                :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
                @updateParentState="this.setValue"
            />
            <File v-else-if='field.type_field == "FILE" || field.type_field == "FILE_LINK"'
                :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :arr='true'
                :border='field.alias == "avatar" ? true : false'
                :single='field.alias == "avatar" || field.file_info && field.file_info.count_max == "1" ? true : false'
                :dataValue='this.dataValues[field.alias]'
                :id='field.alias'
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
                :maxSize="getFileMaxSize(field)"
                :fileInfoText="getFileInfoText(field)"
                @updateParentState="this.setValue"
                :hint='field.hint'
            />
            <SelectMulti v-else-if='field.custom_multi == "1" && field.haslist'
                :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :keywords='this.getKeywords(field)'
                :dataValue='this.dataValues[field.alias]'
                :disable="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :doublebus="this.doublebus"
                :labelTop="isLabelTop"
                :separator="';'"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                @updateParentState="this.setValue"
            />
            <Select v-else-if='field.haslist && field.custom_multi != "1"'
                :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :keywords='this.getKeywords(field)'
                :dataValue='this.dataValues[field.alias]'
                :disable="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :isFilterSelect="true"
                :vMark="this.verifMark"
                :doublebus="this.doublebus"
                :labelTop="isLabelTop"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                @updateParentState="this.setValue"
            />
            <InputDate v-else-if='field.type_field == "DATE"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.prepareDateValue(this.dataValues[field.alias])'
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :expFormat="true"
                :labelTop="isLabelTop"
                @updateParentState="this.setDateValue"
            />
            <InputDate v-else-if='field.type_field == "TIME"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                type='time'
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                @updateParentState="this.setValue"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
            />
            <InputDate v-else-if='field.type_field == "DATETIME"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                type='datetime-local'
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                @updateParentState="this.setValue"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
            />
            <Address v-else-if='field.type_field == "ADDRESS"'
                :id='field.alias'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :label='field.name' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :field="field"
                :addr="this.addr"
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                @updateParentState="this.setValue"
                :verification="field.verification == '1' && field.is_verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :is_public="field.is_public"
                :unvisible="this.unvisible"
                :vMark="this.verifMark"
                :labelTop="isLabelTop"
            />
            <Input v-else-if='field.type_field == "PHONE"'
                type='tel' :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :labelTop="isLabelTop"
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :unvisible="this.unvisible"
                :is_public="field.is_public"
                :vMark="this.verifMark"
                :placeholder="field.custom_example || '+7 (999) 123-45-67'"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                :invalid="this.validationState[field.alias]?.invalid"
                :invalidHint="this.validationState[field.alias]?.invalidHint"
                @updateParentState="this.setValue"
            />
            <Input v-else-if='field.type_field == "INT" || field.type_field == "DECIMAL" || field.type_field == "AMOUNT"'
                type='number' :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :labelTop="isLabelTop"
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :unvisible="this.unvisible"
                :is_public="field.is_public"
                :vMark="this.verifMark"
                :step="field.type_field == 'INT' ? '1' : (field.custom_precision ? Math.pow(10, -field.custom_precision).toString() : '0.01')"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                :invalid="this.validationState[field.alias]?.invalid"
                :invalidHint="this.validationState[field.alias]?.invalidHint"
                @updateParentState="this.setValue"
            />
            <Input v-else
                type='text' :label='field.name'
                :require="this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['obligatory']"
                :id='field.alias' :hint='field.hint'
                :dataValue='this.dataValues[field.alias]'
                :labelTop="isLabelTop"
                :disabled="!(this.conditions[field.alias + '_conditions'] && this.conditions[field.alias + '_conditions']['edit']) || field.verification == '1'"
                :verification="field.verification == '1' ? true : false"
                :unvisibleDataValue="this.unvisibleValue['unvisible_' + field.alias]"
                :unvisible="this.unvisible"
                :is_public="field.is_public"
                :vMark="this.verifMark"
                :maxlength="field.custom_size_max || field.size_max"
                :placeholder="field.custom_example"
                @blurInput="(arg) => {
                    this.blureInput(arg, key)
                }"
                :invalid="this.validationState[field.alias]?.invalid"
                :invalidHint="this.validationState[field.alias]?.invalidHint"
                @updateParentState="this.setValue"
            />
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/components/service/Input';
import Switch from '@/components/service/Switch';
import Select from '@/components/service/Select';
import InputDate from '@/components/service/InputDate';
import File from '@/components/service/File';
import Address from '@/components/service/Address';
import SelectMulti from '@/components/service/SelectMulti';

/**
 * Field type aliases from msform microservice:
 * - STRING (10): Simple text input
 * - BOOL (30): Boolean (checkbox/switch)
 * - INT (40): Integer number
 * - AMOUNT (50): Payment amount
 * - DECIMAL (60): Decimal number
 * - DATE (70): Date picker
 * - TIME (71): Time picker
 * - DATETIME (72): Date and time picker
 * - FILE (80): File upload
 * - SELECT (100): Selection list
 * - CARD (200): Card number
 * - MONTH_YEAR (210): Month/Year picker
 * - PHONE (220): Phone number
 * - ADDRESS (230): Address (FIAS)
 * - BIC (240): Bank BIC
 * - TEMPLATE (250): Template field
 * - CURR (300): Currency selector
 * - KEYT (310): Account number
 * - COUNTRY (320): Country selector
 * - TARIFF_PLAN (410): Tariff plan selector
 * - TARIFF_PLAN_MEMBER (411): Member tariff plan
 * - SUPPORT_CATEGORY (420): Support category
 * - KEYT_STAT (430): Account type
 * - DIGITAL_PASSPORT (440): Digital passport
 * - CARD_TOKEN (450): Card tokens
 * - FORM (460): Form selector
 * - NOTIFY (480): Notification method
 * - FILE_LINK (500): File link
 */

export default {
    components: {
        Input,
        Switch,
        Select,
        InputDate,
        File,
        Address,
        SelectMulti
    },
    data() {
        return {
            unvisibleValue: this.unvisibleDataValues ? this.getValues(this.unvisibleDataValues) : false,
            conditions: {},
            containerWidth: 0,
            validationState: {}
        }
    },
    props: {
        fields: [Boolean, Object, Array],
        dataValues: [Boolean, Object],
        unvisibleDataValues: [Boolean, Object],
        unvisible: [Boolean],
        verifMark: [Boolean],
        addr: [Boolean, Object],
        doublebus: [Boolean],
        onAlias: [Boolean]
    },
    created() {
        this.conditions = this.setConditions();
    },
    computed: {
        isLabelTop() {
            return this.containerWidth > 0 && this.containerWidth <= 768;
        },
        /**
         * Normalize fields to unified format
         * Supports both legacy format and new msform format
         */
        normalizedFields() {
            if (!this.fields) return null;

            const fieldsArray = Array.isArray(this.fields) ? this.fields : Object.values(this.fields);

            return fieldsArray.map(field => this.normalizeField(field));
        }
    },
    methods: {
        /**
         * Normalize a single field to unified format
         * Handles both legacy format (type_field) and msform format (field_type + field_type_name)
         */
        normalizeField(field) {
            // If already has type_field (legacy format), return as-is with minor enhancements
            if (field.type_field) {
                return {
                    ...field,
                    haslist: this.fieldHasList(field)
                };
            }

            // Convert msform format to legacy format
            // field_type_name contains human-readable name, so we use field_type code to get alias
            const typeAlias = this.getTypeAlias(field.field_type);

            return {
                ...field,
                // Map msform fields to legacy field names
                type_field: typeAlias,
                // Conditions mapping (use ?? to preserve 0 and '0' values)
                edit_conditions: field.editable_conditions ?? '1',
                visible_conditions: field.visible_conditions ?? '1',
                obligatory_conditions: field.obligatory_conditions ?? '1',
                // Size constraints
                size_min: field.custom_size_min,
                size_max: field.custom_size_max,
                // Regexp from field_type or custom
                re: field.regexp || field.custom_regexp,
                // Multi-select flag (convert boolean to string for legacy compatibility)
                custom_multi: field.custom_multi ? '1' : '0',
                // Has list flag
                haslist: this.msformFieldHasList(field, typeAlias),
                // Lists from field_options
                lists: this.convertFieldOptions(field.field_options)
            };
        },

        /**
         * Check if legacy field has a list
         */
        fieldHasList(field) {
            if (field.haslist !== undefined) return field.haslist;
            if (field.lists && field.lists.length > 0) return true;
            if (field.type_num_val && field.type_text_val) return true;
            return false;
        },

        /**
         * Check if msform field has a list
         */
        msformFieldHasList(field, typeAlias) {
            // Types that are inherently lists
            const listTypes = ['SELECT', 'CURR', 'KEYT', 'COUNTRY', 'TARIFF_PLAN',
                'TARIFF_PLAN_MEMBER', 'SUPPORT_CATEGORY', 'KEYT_STAT',
                'DIGITAL_PASSPORT', 'CARD_TOKEN', 'FORM'];

            if (listTypes.includes(typeAlias)) return true;

            // Check if has field_options
            if (field.field_options && field.field_options.length > 0) return true;

            return false;
        },

        /**
         * Convert field_options from msform format to legacy keywords format
         */
        convertFieldOptions(options) {
            if (!options || !Array.isArray(options) || options.length === 0) {
                return null;
            }

            return options.map(opt => ({
                code: opt.value,
                value: opt.text
            }));
        },

        /**
         * Get type alias from field_type code (fallback if field_type_name not provided)
         */
        getTypeAlias(code) {
            const typeMap = {
                10: 'STRING',
                30: 'BOOL',
                40: 'INT',
                50: 'AMOUNT',
                60: 'DECIMAL',
                70: 'DATE',
                71: 'TIME',
                72: 'DATETIME',
                80: 'FILE',
                100: 'SELECT',
                200: 'CARD',
                210: 'MONTH_YEAR',
                220: 'PHONE',
                230: 'ADDRESS',
                240: 'BIC',
                250: 'TEMPLATE',
                300: 'CURR',
                310: 'KEYT',
                320: 'COUNTRY',
                410: 'TARIFF_PLAN',
                411: 'TARIFF_PLAN_MEMBER',
                420: 'SUPPORT_CATEGORY',
                430: 'KEYT_STAT',
                440: 'DIGITAL_PASSPORT',
                450: 'CARD_TOKEN',
                460: 'FORM',
                480: 'NOTIFY',
                500: 'FILE_LINK'
            };
            return typeMap[code] || 'STRING';
        },

        getFileMaxSize(field) {
            if (field.file_info && field.file_info.size_max) {
                return Number(field.file_info.size_max);
            }
            return false;
        },
        getFileInfoText(field) {
            let formats = field.file_info && field.file_info.formats
                ? field.file_info.formats
                : this.$t('components.service.GetInputs.13');
            const maxSize = this.getFileMaxSize(field);
            if (maxSize) {
                return `${formats} (${this.$t('components.service.GetInputs.12')} ${maxSize} MB)`;
            }
            return formats;
        },
        updateContainerWidth() {
            if (this.$refs.inputsContainer) {
                this.containerWidth = this.$refs.inputsContainer.offsetWidth;
            }
        },
        setValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                unvisible: arg.unvisible,
                value: arg.value
            })
        },
        setDateValue(arg) {
            let d = arg.value;
            let v = false;
            if (d) {
                v = [
                    this.padTo2(d.getDate()),
                    this.padTo2(d.getMonth() + 1),
                    d.getFullYear()
                ].join('.');
            }
            this.$emit('updateParentState', {
                id: arg.id,
                unvisible: arg.unvisible,
                value: v
            })
        },
        setConditions() {
            let ec = {};
            if (!this.normalizedFields || !Array.isArray(this.normalizedFields)) {
                return ec;
            }
            this.normalizedFields.forEach((e) => {
                ec[e.alias + '_conditions'] = this.checkConditions(e);
            })
            return ec;
        },
        prepareDateValue(arg) {
            if (!arg) {
                return '';
            }
            let a = arg.split('.');
            let v = [a[2], a[1], a[0]].join('-');
            return v;
        },
        padTo2(v) {
            return v.toString().padStart(2, '0');
        },
        /**
         * Build regex pattern from custom_symbol_set string
         * @param {string} symbolSet - Semicolon-separated values: Latin;Cyrillic;Numbers;Special
         * @returns {RegExp|null} - Regex for allowed characters or null if no restrictions
         */
        buildSymbolSetRegex(symbolSet) {
            if (!symbolSet) return null;

            const parts = symbolSet.split(';').map(s => s.trim()).filter(Boolean);
            if (parts.length === 0) return null;

            let pattern = '';

            if (parts.includes('Latin')) {
                pattern += 'A-Za-z';
            }
            if (parts.includes('Cyrillic')) {
                pattern += 'А-Яа-яЁё';
            }
            if (parts.includes('Numbers')) {
                pattern += '0-9';
            }
            if (parts.includes('Special')) {
                pattern += '!?@#%&*+=/_\\\\\\-\\s\\.,:;\'"()\\[\\]{}';
            }

            if (!pattern) return null;

            return new RegExp(`^[${pattern}]*$`);
        },

        /**
         * Get human-readable list of allowed character types
         * @param {string} symbolSet - Semicolon-separated values
         * @returns {string} - Comma-separated list for error message
         */
        getSymbolSetDescription(symbolSet) {
            if (!symbolSet) return '';

            const parts = symbolSet.split(';').map(s => s.trim()).filter(Boolean);
            const descriptions = [];

            if (parts.includes('Latin')) {
                descriptions.push(this.$t('components.service.GetInputs.7') || 'Latin letters');
            }
            if (parts.includes('Cyrillic')) {
                descriptions.push(this.$t('components.service.GetInputs.8') || 'Cyrillic letters');
            }
            if (parts.includes('Numbers')) {
                descriptions.push(this.$t('components.service.GetInputs.9') || 'numbers');
            }
            if (parts.includes('Special')) {
                descriptions.push(this.$t('components.service.GetInputs.10') || 'special characters');
            }

            return descriptions.join(', ');
        },

        validateAll() {
            // Прогоняем проверку по всем полям, чтобы подсветить сразу все
            // незаполненные обязательные (а не только то, с которого ушли по blur).
            // Возвращаем общую валидность для вызывающего компонента.
            if (!this.normalizedFields) return true;
            let valid = true;
            this.normalizedFields.forEach((field, key) => {
                const value = this.dataValues?.[field.alias] ?? '';
                this.checkReg({ value }, key);
                if (this.validationState[field.alias]?.invalid) valid = false;
            });
            return valid;
        },
        checkReg(arg, key) {
            const fields = this.normalizedFields;
            const fieldAlias = fields[key].alias;

            // Reset validation state
            this.validationState[fieldAlias] = { invalid: false, invalidHint: '' };

            if (arg.value != '') {
                const sizeMin = fields[key].custom_size_min || fields[key].size_min;
                const sizeMax = fields[key].custom_size_max || fields[key].size_max;
                if (sizeMin && sizeMax && (arg.value.length < sizeMin || arg.value.length > sizeMax)) {
                    this.validationState[fieldAlias] = {
                        invalid: true,
                        invalidHint: `${this.$t('components.service.GetInputs.1')} ${sizeMin} ${this.$t('components.service.GetInputs.2')} ${sizeMax} ${this.$t('components.service.GetInputs.3')}`
                    };
                    return;
                }

                // Check custom_symbol_set validation
                if (fields[key].custom_symbol_set) {
                    const symbolSetRegex = this.buildSymbolSetRegex(fields[key].custom_symbol_set);
                    if (symbolSetRegex && !symbolSetRegex.test(arg.value)) {
                        const allowedTypes = this.getSymbolSetDescription(fields[key].custom_symbol_set);
                        this.validationState[fieldAlias] = {
                            invalid: true,
                            invalidHint: `${this.$t('components.service.GetInputs.11') || 'Allowed characters:'} ${allowedTypes}`
                        };
                        return;
                    }
                }

                if (fields[key].re || fields[key].custom_regexp) {
                    let re = new RegExp(fields[key].re || fields[key].custom_regexp);
                    if (re.test(arg.value) == false) {
                        this.validationState[fieldAlias] = {
                            invalid: true,
                            invalidHint: `${this.$t('components.service.GetInputs.4')}`
                        };
                    }
                }
            } else if (fields[key].obligatory_conditions === '1') {
                this.validationState[fieldAlias] = {
                    invalid: true,
                    invalidHint: `${this.$t('components.service.GetInputs.5')}`
                };
            }

        },
        blureInput(arg, key) {
            this.checkReg(arg,key);
            this.$emit('blureInput', {
                id: arg.id,
                value: arg.value,
                key: key,
            })
        },
        getValues(obj) {
            let res = {}
            for (let key in obj) {
                res[key] = obj[key] ? obj[key] : '';
            }
            return res
        },
        getKeywords(field) {
            if (field.type_field == 'KEYT') {
                let keyts = this.$store.getters.get_keyts_keywords
                return keyts
            } else if (field.lists) {
                return field.lists;
            } else if (field.type_num_val && field.type_text_val) {
                let codes = field.type_num_val.split('|');
                let vals = field.type_text_val.split('|');
                let arr = [];
                for (let i = 0; i < codes.length; i++) {
                    arr.push({'code': codes[i], 'value': vals[i]})
                }
                return arr;
            }
            return [];
        },
        checkConditions(field) {
            let res = {
                edit: true,
                visible: true,
                obligatory: true
            }

            let editConditions = this.parseConditions(field.edit_conditions || field.editable_conditions);
            res.edit = this.evalConditions(editConditions)

            let visibleConditions = this.parseConditions(field.visible_conditions);
            res.visible = this.evalConditions(visibleConditions)

            let obligatoryConditions = this.parseConditions(field.obligatory_conditions);
            res.obligatory = this.evalConditions(obligatoryConditions, false)
            return res;
        },
        parseConditions(str) {
            if (str === undefined || str === null || str === '') {
                return false;
            }

            // Handle simple boolean values: 0, 1, '0', '1', false, true
            if (str === 0 || str === '0' || str === false) {
                return 'false';
            }
            if (str === 1 || str === '1' || str === true) {
                return 'true';
            }

            try {
                let result = String(str);

                // Replace ALIAS:field_name with actual values from dataValues
                // Format: ALIAS:field_name or just field_name
                result = result.replace(/ALIAS:([a-zA-Z0-9_-]+)/g, (_, alias) => {
                    if (this.dataValues && this.dataValues[alias] !== undefined) {
                        const val = this.dataValues[alias];
                        // Return quoted string for string values, raw for numbers
                        if (typeof val === 'string' && isNaN(Number(val))) {
                            return `"${val}"`;
                        }
                        return val === '' ? '""' : val;
                    }
                    return '""'; // Return empty string if field not found
                });

                // Replace <> with != (must be before = replacement)
                result = result.replace(/<>/g, '!=');

                // Replace single = with == (but not >=, <=, !=, ==)
                // Use negative lookbehind and lookahead
                result = result.replace(/(?<![<>!=])=(?!=)/g, '==');

                // Fix any accidental ==== or === back to ==
                result = result.replace(/===+/g, '==');

                // Replace remaining field aliases (without ALIAS: prefix) with dataValues
                const fieldAliases = [...result.matchAll(/\b([a-zA-Z_][a-zA-Z0-9_-]*)\b/g)];
                fieldAliases.forEach((match) => {
                    const alias = match[1];
                    // Skip JavaScript keywords and already processed values
                    if (['true', 'false', 'null', 'undefined', 'this', 'dataValues'].includes(alias)) {
                        return;
                    }
                    if (this.dataValues && this.dataValues[alias] !== undefined) {
                        const val = this.dataValues[alias];
                        let replacement;
                        if (typeof val === 'string' && isNaN(Number(val))) {
                            replacement = `"${val}"`;
                        } else {
                            replacement = val === '' ? '""' : val;
                        }
                        // Use word boundary replacement
                        result = result.replace(new RegExp(`\\b${alias}\\b`, 'g'), replacement);
                    }
                });

                return result;
            } catch (error) {
                if (this.$store.state.config.CONSOLE_LOGS) {
                    this.$lib.throwWarning(this.$store, "Can't parse conditional operator "+str + "\n" + error, 'error');
                }
                return false;
            }
        },
        evalConditions(str, def = true) {
            if (!str) {
                return def;
            }
            try {
                return Boolean(eval(str));
            } catch (error) {
                if (this.$store.state.config.CONSOLE_LOGS) {
                    this.$lib.throwWarning(this.$store, "Can't use conditional operator "+str + "\n" + error, 'error');
                }
                return def;
            }
        }
    },
    mounted() {
        this.updateContainerWidth();
        window.addEventListener('resize', this.updateContainerWidth);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateContainerWidth);
    },
    watch: {
        dataValues: {
            handler(newValue, oldValue) {
                if (this.normalizedFields) {
                    this.normalizedFields.forEach((e) => {
                        this.conditions[e.alias + '_conditions'] = this.checkConditions(e);
                    })
                }
            },
            deep: true
        },
        fields: {
            handler() {
                this.conditions = this.setConditions();
            },
            deep: true,
            immediate: true
        }
    }

}
</script>

<style lang="scss" scoped>
    .tst {
        .container-fluid:first-child {
            div {
                margin-top: 0 !important;
            }
        }
    }
</style>
